var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgDrayage = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  viewBox: "0 0 26 26"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#D5EBEF",
  d: "M17 20c-.3 0-.5-.2-.5-.5V5.4H5.4c-.2 0-.5.1-.6.3-.1 0-.3.2-.2.4v3.4c0 .3-.2.5-.5.5s-.5-.2-.5-.5V6.1c-.1-.4.1-.8.4-1.1s.8-.6 1.3-.6h12.2v15.1c0 .2-.2.5-.5.5M6.4 20H3.6v-2.5c0-.3.2-.5.5-.5s.5.2.5.5V19h1.9c.3 0 .5.2.5.5s-.3.5-.6.5"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#D5EBEF",
  d: "M18.8 20h-7.7c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h7.7c.3 0 .5.2.5.5s-.2.5-.5.5M25.8 20h-2.2c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h1.2v-6.3H17c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h8c.4 0 .8.3.8.8z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#D5EBEF",
  d: "M25.3 12.7c-.2 0-.3-.1-.4-.2l-3.4-5.8H17c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h5l3.7 6.3c.1.2.1.5-.2.7z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#129BF9",
  d: "M.7 14.5h5.4v1H.7zM3.3 11.4h2.8v1H3.3z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#86A7B2",
  d: "M8.7 21.6c-1.4 0-2.5-1.1-2.5-2.5s1.1-2.5 2.5-2.5 2.5 1.1 2.5 2.5-1.2 2.5-2.5 2.5m0-4c-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5 1.5-.7 1.5-1.5-.7-1.5-1.5-1.5M21.3 21.6c-1.4 0-2.5-1.1-2.5-2.5s1.1-2.5 2.5-2.5 2.5 1.1 2.5 2.5-1.2 2.5-2.5 2.5m0-4c-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5 1.5-.7 1.5-1.5-.7-1.5-1.5-1.5"
})));
export default SvgDrayage;